import { useSceneEntities } from "@/stores/SceneEntities";

export function useMaterialGlassRain(payload, viewport) {
  const sceneEntities = useSceneEntities();  
  if (!payload.enabled) {
    sceneEntities.configuratorView.viewportComponent.removeMaterialUpdateForSerialization(payload.key);
    return;
}   
sceneEntities.configuratorView.viewportComponent.storeMaterialUpdateForSerialization({key:payload.key});
  //glass_1--------------------------------------------------------------------

 let materialUpdateObject = {};
 materialUpdateObject.name = "glass_1";

 materialUpdateObject.props = {};   
 materialUpdateObject.props.alpha = 0.37;
 materialUpdateObject.colors = {};
 materialUpdateObject.colors.albedoColor ="glass_color_4";

 materialUpdateObject.textures = {};
/*
 materialUpdateObject.textures.metallicTexture = {};
 materialUpdateObject.textures.metallicTexture.key ="glass_rain_rough";
 materialUpdateObject.textures.metallicTexture.textureProperties = {};
 materialUpdateObject.textures.metallicTexture.textureProperties.vScale = -1;*/

 /*
 materialUpdateObject.textures.bumpTexture = {};
 materialUpdateObject.textures.bumpTexture.key ="glass_rain_normal";
 materialUpdateObject.textures.bumpTexture.textureProperties = {};
 materialUpdateObject.textures.bumpTexture.textureProperties.vScale = -1;*/

 // base material IOR
  materialUpdateObject.props.indexOfRefraction = 3;

  // clear coat (must be under props so your loop assigns it)
  materialUpdateObject.propsNested = {}
materialUpdateObject.propsNested.clearCoat = {}
  materialUpdateObject.propsNested.clearCoat.isEnabled = true;
 materialUpdateObject.propsNested.clearCoat.intensity = 1;
 materialUpdateObject.propsNested.clearCoat.roughness = 0.77;
 materialUpdateObject.propsNested.clearCoat.indexOfRefraction = 2;
 materialUpdateObject.propsNested.clearCoat.useRoughnessFromMainTexture = false

  materialUpdateObject.textures["clearCoat.bumpTexture"] = {
    key: "glass_rain_normal",
    textureProperties: {
      vScale: -1,
      level: 0.24,
    },
  };

   materialUpdateObject.textures["clearCoat.textureRoughness"] = {
    key: "glass_rain_rough",
    textureProperties: {
      vScale: -1,
     
    },
  };


 viewport.updateMaterial(materialUpdateObject)
 
}
